export default function getPaginationParams(pageNumber: number = 1, pageSize: number = 20): string {
    return `limit=${pageSize}&offset=${(pageNumber - 1) * pageSize}`
}